import React, { Component } from 'react';

// Import components
import SendReceiptForm from '../payment/send-receipt-form';
import {connect} from 'react-redux';

class PaymentReceiptDelivery extends Component {
  constructor(props) {
    super(props);

    this.state = {
      details: null,
      email: '',
      phoneNo: '',
    };

    let data = JSON.parse(this.props.data);

    if (this.props.client.receiptAutoFillEmailPhone) {
      for (let i = 0; i < data.installEmailAddresses.length; i++) {
        if (data.installEmailAddresses[i].isPrimary) {
          this.state.email = data.installEmailAddresses[i].emailAddrText;
          break;
        }
      }
      this.state.phoneNo = data.installMobilePhone.mobilePhoneNo;
    }
  }

  handleSendReceipt = (values) => {
    values.receiptId = this.props.id;
    this.props.onSendReceipt(values);
  }

  /**
   * Render the component view.
   */
  render() {
    let initialValues = {email: this.state.email, phoneNo: this.state.phoneNo};

    return (
      <div className="modal--width-500px">
        <div className="modal__header">
          <h3 className="delivery-receipt-modal__title">Email / SMS Receipt</h3>
        </div>

        <div className="modal__body">
          <div className="delivery-receipt-modal__body">
            <p className="delivery-receipt-modal__message">
              Enter recipient email address or mobile phone number below and we’ll send them a payment receipt.
            </p>

            {/* Form to send the receipt to email or phone number */}
            <SendReceiptForm initialValues={initialValues} enableReinitialize={true} onSubmit={ this.handleSendReceipt } />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    client: state.client.data,
    data: localStorage.getItem('userData')
  }
};

export default connect(mapStateToProps)(PaymentReceiptDelivery);



// WEBPACK FOOTER //
// ./src/components/receipts/payment-receipt-delivery.js